// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121619/js/" + chunkId + "." + {"44":"6f6cff9d","225":"192c8b1f","481":"cadd1368","486":"070e60df","770":"8b8a7272"}[chunkId] + ".0.7169487799563142.chunk.js";
};